module.exports = __webpack_public_path__ + "img/DSC_2226_referencia_thumb.74cb9298.jpg";